module.exports = __webpack_public_path__ + "img/bespoke70_28.8fa210d9.jpg";